<script setup lang="ts"></script>

<template>
  <div class="max-w-7xl mx-auto px-8">
    <h1 class="text-5xl pb-12">Bewerbung zur Zeit nicht möglich</h1>
    <div class="flex flex-col space-y-8">
      <p>
        Leider hast du diese Seite außerhalb des Bewerbungszeitraums aufgerufen. Ab Mai und bis Ende
        Oktober kannst du dich wieder bei uns bewerben. Wir freuen uns auf deine Bewerbung!
      </p>
      <div>
        <a href="https://sternsinger-freiwilligendienst.de" class="button button--primary">Zur Website</a>
      </div>
    </div>
  </div>
</template>
